'use client';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { ArrowArrowRight } from '@s7/icons';
import { Stack, Group, Flex } from '@s7/layout';
import { packSX } from '@s7/styles';
import { TextField, Checkbox, Button } from '@s7/ui';
import { Titles } from './layouts/Titles.js';
import { textFieldStyles, blockSX } from './FooterSubscriptions.styles.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const checkboxSX = (theme)=>({
        paddingLeft: theme.fn.space('0.5s')
    });
const buttonSX = (theme)=>({
        height: 48,
        borderRadius: theme.fn.borderRadius('1.5r')
    });
const FooterSubscriptions = (props)=>{
    const { agreed, onAgreementChange, title, subtitle, agreement, buttonProps, onSubmit, textFieldRef, textFieldProps, checkboxProps } = props, others = _object_without_properties_loose(props, [
        "agreed",
        "onAgreementChange",
        "title",
        "subtitle",
        "agreement",
        "buttonProps",
        "onSubmit",
        "textFieldRef",
        "textFieldProps",
        "checkboxProps"
    ]);
    const Input = /*#__PURE__*/ jsx(TextField, _extends({
        ref: textFieldRef,
        styles: textFieldStyles
    }, textFieldProps));
    const MainControls = agreement ? /*#__PURE__*/ jsxs(Stack, {
        breakpoints: {
            'md1.up': {
                spacing: 8,
                stretch: false
            }
        },
        spacing: 20,
        stretch: true,
        children: [
            Input,
            /*#__PURE__*/ jsx(Checkbox, _extends({
                wrapperProps: {
                    align: 'start'
                },
                size: "xs1"
            }, checkboxProps, {
                checked: agreed,
                label: agreement,
                sx: [
                    checkboxSX,
                    ...packSX(checkboxProps == null ? void 0 : checkboxProps.sx)
                ],
                required: true,
                onChange: (event)=>onAgreementChange == null ? void 0 : onAgreementChange(event.target.checked)
            }))
        ]
    }) : Input;
    const Controls = /*#__PURE__*/ jsxs(Group, {
        align: "start",
        spacing: 12,
        noWrap: true,
        children: [
            MainControls,
            /*#__PURE__*/ jsx(Button, _extends({
                leftSide: /*#__PURE__*/ jsx(ArrowArrowRight, {
                    size: 20
                }),
                title: "Подписаться",
                type: "submit",
                width: 72
            }, buttonProps, {
                disabled: !agreed || (buttonProps == null ? void 0 : buttonProps.disabled),
                sx: [
                    buttonSX,
                    ...packSX(buttonProps == null ? void 0 : buttonProps.sx)
                ]
            }))
        ]
    });
    return /*#__PURE__*/ jsxs(Flex, _extends({
        breakpoints: {
            'md1.up': {
                direction: 'row',
                justify: 'space-between'
            }
        },
        as: "form",
        direction: "column",
        spacing: 20,
        sx: blockSX,
        onSubmit: onSubmit
    }, others, {
        children: [
            /*#__PURE__*/ jsx(Titles, {
                subtitle: subtitle,
                title: title
            }),
            Controls
        ]
    }));
};

export { FooterSubscriptions };
//# sourceMappingURL=FooterSubscriptions.js.map
